module.exports = {"AUTH0_AUDIENCE":"https://sandbox.api.material.com","AUTH0_DOMAIN":"shopper-sandbox.auth0.com"}


//////////////////
// WEBPACK FOOTER
// ./config/sandbox.json
// module id = 727
// module chunks = 0